import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { mapScaleToPeriodResolution } from '../util';

export const USER_SCHEDULE_BACKGROUND_QUERY = gql`
  query userScheduleBackgroundImage(
    $dateRange: DateRangeInput!
    $periodResolution: PeriodResolutionOption!
    $filter: GetResourceUsersFilter!
  ) {
    resourceUsers2(filter: $filter) {
      id
      resourceUserScheduleSvg(
        dateRange: $dateRange
        periodResolution: $periodResolution
      ) {
        svgContent
      }
    }
  }
`;

const useUserScheduleBackgroundImage = ({
  userUri,
  dateRange,
  scale,
  skip = false
}) => {
  const { data } = useQuery(USER_SCHEDULE_BACKGROUND_QUERY, {
    variables: {
      filter: {
        userIds: [userUri]
      },
      dateRange,
      periodResolution: mapScaleToPeriodResolution(scale)
    },
    skip
  });

  return {
    userScheduleBackgroundImage:
      data?.resourceUsers2?.[0]?.resourceUserScheduleSvg?.svgContent
  };
};

export default useUserScheduleBackgroundImage;
